var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29289 6.99797C5.68342 7.3885 6.31658 7.3885 6.70711 6.99797L11.2946 2.41046C11.6842 2.02089 11.6842 1.38927 11.2946 0.999694C10.9053 0.610421 10.2743 0.610077 9.88462 0.998925L6.70634 4.17028C6.31599 4.55978 5.68401 4.55978 5.29366 4.17028L2.11538 0.998925C1.72569 0.610077 1.09466 0.610421 0.705384 0.999694C0.315811 1.38927 0.315811 2.02089 0.705384 2.41046L5.29289 6.99797Z",
    fill: "#113D18"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-down.8af6e23b.svg";
export { ForwardRef as ReactComponent };